<template>
  <app-loading :loading="loading">
    <v-card>
      <v-card-title class="py-1" style="background-color: #29284c">
        <span class="white--text">
          <slot name="title"> {{ dictionary[item.type] }} #{{ index + 1 }} </slot>
        </span>
        <template v-if="$store.getters.profile.role === 'TEACHER'">
          <v-spacer />
          <v-btn color="red" icon :loading="loadingDelete" @click="deleteHomework">
            <v-icon> mdi-delete </v-icon>
          </v-btn>
        </template>
      </v-card-title>
      <v-divider />
      <v-card-text class="text--primary">
        <component :is="item.type" :data="homework" />
      </v-card-text>
    </v-card>
  </app-loading>
</template>
<script>
import { getHomeworkById, deleteHomework } from "@/api/api";
import studentMixin from "@/mixins/studentMixin";
import Loading from "../../../../../Loading.vue";

export default {
  components: {
    Recording: () => import("./Recording.vue"),
    Retelling: () => import("./Retelling.vue"),
    Monologue: () => import("./Monologue.vue"),
    Custom: () => import("./Custom.vue"),
    appLoading: Loading,
  },
  props: {
    item: Object,
    index: Number,
  },
  mixins: [studentMixin],
  data() {
    return {
      homework: { question_group: { questions: [{ content: "" }] } },
      loading: false,
      loadingDelete: false,
      dictionary: {
        Recording: "Lesson Text Recording",
        Retelling: "Written Retelling",
        Monologue: "Writing Log",
        Custom: "Custom Homework",
      },
    };
  },
  methods: {
    async seeHomework() {
      try {
        this.loading = true;
        const response = await getHomeworkById(this.item.uuid);
        this.homework = response.data;
      } finally {
        this.loading = false;
      }
    },
    async deleteHomework() {
      this.loadingDelete = true;
      try {
        await deleteHomework(this.item.uuid);
        this.$emit("homework-deleted", this.item.uuid);
      } finally {
        this.loadingDelete = false;
      }
    },
  },
  watch: {
    "item.uuid"(v) {
      if (v) {
        this.seeHomework();
      }
    },
  },
  mounted() {
    this.seeHomework();
  },
};
</script>
